// ** Initial State
const initialState = {
  allData: [],
  allAddonSubscribers: [],
  data: [],
  total: 1,
  params: {},
  currentUser: null,
  selectedUser: null,
  selectedBook: null,
  bookEdit: false,
  customPagination: null,
  currentSelectedAddonId: null,
  openAddonNotiModel: false,
  notifyId: null,
  notifyUser: null,
  allSelectedAddonUsersForNoti: [],
  allSelectedAddonUserNamesForNoti: [],
  token: JSON.parse(localStorage.getItem("accessToken")),
  found_results: '',
  entries_per_page: '',
  total_results: ''

}

// console.log('sssssssssssss', selectedUser)

const addonSubscriptions = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_ADDONSUBSCRBERS':
      console.log(action.data)
      return { ...state, allAddonSubscribers: action.data, customPagination: action.customTotal, currentSelectedAddonId: action.currentSelectedAddonId, entries_per_page: action.entries_per_page, found_results: action?.found_results, total_results: action?.total_results  }
    case 'NOTIFYADDONID':
      return {...state, openAddonNotiModel: true, notifyId: action.id, notifyUser: action.notifyUser }
    case 'CANCELADDONUSER':
      return {...state, allAddonSubscribers: action.data}
    case 'SELECTED_ADDON_USER_FOR_NOTI':
        console.log(action.names);
        return {...state, allSelectedAddonUsersForNoti: action.payload, allSelectedAddonUserNamesForNoti: action.names}
    case 'CLOSE_NOTI_ADDON_MODEL_ADDON':
      return {...state, openAddonNotiModel: false}
    case 'SUBMIT_CLOSE_NOTI_ADDON_MODEL_ADDON':
      return {...state, openAddonNotiModel: false, allSelectedAddonUsersForNoti: [], allSelectedAddonUserNamesForNoti: [] }
    case 'OPEN_ADDDON_NOTI_MODEL':
        return {...state, openAddonNotiModel: true}
    case 'GET_BOOK_DATA':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_USER':
      console.log(action)
      return { ...state, selectedUser: action.selectedUser }
    case 'ADD_USER':
    return {...state, allData: action.data}
    case 'DELETE_BOOK':
      console.log(action.data)
      return { ...state, allAddonSubscribers: action.data }
    case 'EDITBOOK':
      return {...state, selectedBook: action.data}
    case 'BOOK_PAGE_CHANGE':
      return {...state, allAddonSubscribers: []}
    // case 'START_LOADING':
    //   return {...state, loading: true}
    // case 'END_LOADING':
    //   return {...state, loading: false}
    default:
      return { ...state }
  }
}
export default addonSubscriptions
